/**
 * @author Madhu Sudhan
 * @Date: 2023-09-07 12:34:11
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-09-07 10:47:49
 */
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Button, Card, Col, Divider, Form, Input, Modal, Row, Radio } from 'antd';
import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../Root/HOC';
import { Container } from '../../components';
import { constants, utils, validationRules } from '../../devUtils';
import { CALCULATE_BALANCE_YSC } from '../NetworkCards/constants';
import { BLOCK_CARD_PATH, LOCK_CARD_PATH, YSCCARD_CONSTANTS, radioOptions } from './constants';
import { StyledIdfcFlipCards, StyledYscFlipCards, background, backgroundColour, margin } from '../NetworkCards/StyledNetworkCard';
import { YscCardActionsProps, mapDispatchToProps, mapStateToProps } from './YscCardActionsDataHandler';
import { CardActionsPage } from './CardActionsPage';
import { formatExpiryDate } from '../../devUtils/commonUtils';

const { TextArea } = Input;

class YscCardActions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalType: '',
      reasonForLock: '',
      reasonForUnlock: '',
      OTP: '',
      showResendText: false,
      remainingTime: 60,
      selectedRadioValue: 'BL',
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this);
    this.handleResendOTP = this.handleResendOTP.bind(this);
    this.verifyBlockCardOTP = this.verifyBlockCardOTP.bind(this);
    this.verifyLockCardOTP = this.verifyLockCardOTP.bind(this);
    this.verifyUnlockCardOTP = this.verifyUnlockCardOTP.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      },
      onFetchCardData,
    } = this.props;
    onFetchCardData(ysc_card_id);
  }

  componentWillReceiveProps(nextProps) {
    const {
      history,
      BlockCardOtpSuccess,
      BlockCardOtpSuccess: { status: blockCardOtpSuccessStatus = false },
      LockCardOtpSuccess,
      LockCardOtpSuccess: { status: lockCardOtpSuccessStatus = false },
      UnlockCardOtpSuccess,
      UnlockCardOtpSuccess: { status: unlockCardOtpSuccessStatus = false },
      BlockCardSuccess,
      BlockCardSuccess: { status: blockCardSuccessStatus = false },
      LockCardSuccess,
      LockCardSuccess: { status: lockCardSuccessStatus = false },
      UnlockCardSuccess,
      UnlockCardSuccess: { status: unlockCardSuccessStatus = false },
    } = nextProps;
    const {
      BlockCardOtpSuccess: _BlockCardOtpSuccess,
      LockCardOtpSuccess: _LockCardOtpSuccess,
      UnlockCardOtpSuccess: _UnlockCardOtpSuccess,
      BlockCardSuccess: _BlockCardSuccess,
      LockCardSuccess: _LockCardSuccess,
      UnlockCardSuccess: _UnlockCardSuccess,
    } = this.props;
    if (!utils.isEqual(BlockCardOtpSuccess, _BlockCardOtpSuccess) && blockCardOtpSuccessStatus) {
      this.setState({ modalType: 'BLOCK_CARD_OTP' });
      this.startTimer();
    } else if (!utils.isEqual(LockCardOtpSuccess, _LockCardOtpSuccess) && lockCardOtpSuccessStatus) {
      this.setState({ modalType: 'LOCK_CARD_OTP', OTP: '', showResendText: false, remainingTime: 60 });
      this.startTimer();
    } else if (!utils.isEqual(UnlockCardOtpSuccess, _UnlockCardOtpSuccess) && unlockCardOtpSuccessStatus) {
      this.setState({ modalType: 'UNLOCK_CARD_OTP' });
      this.startTimer();
    } else if (!utils.isEqual(BlockCardSuccess, _BlockCardSuccess) && blockCardSuccessStatus) {
      this.setState({
        OTP: '',
      });
      this.handleModal();
      utils.forceRedirect(history, { pathname: history.goBack() });
    } else if (!utils.isEqual(LockCardSuccess, _LockCardSuccess) && lockCardSuccessStatus) {
      this.setState({
        OTP: '',
        reasonForLock: '',
      });
      this.handleModal();
      utils.forceRedirect(history, { pathname: history.goBack() });
    } else if (!utils.isEqual(UnlockCardSuccess, _UnlockCardSuccess) && unlockCardSuccessStatus) {
      this.setState({
        OTP: '',
        reasonForUnlock: '',
      });
      this.handleModal();
      utils.forceRedirect(history, { pathname: history.goBack() });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
  }

  onRadioButtonChange(value) {
    this.setState({ selectedRadioValue: value });
  }

  setWidth(type) {
    switch (type) {
      case 'BLOCK_CARD_CONFIRMATION':
      case 'LOCK_CARD_CONFIRMATION':
      case 'UNLOCK_CARD_CONFIRMATION':
        return '500px';
      default:
        return '600px';
    }
  }

  handleOtpChange(OTP) {
    this.setState({ OTP });
  }

  handleResendOTP(type) {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onInitPosPinReset,
      onBlockCard,
      onUnlockCard,
    } = this.props;
    const { reasonForLock, reasonForUnlock } = this.state;
    switch (type) {
      case 'BLOCK_CARD':
        onInitPosPinReset({ ysc_card_id }, { otp_type: 'permanent_block_ysc_card' });
        break;
      case 'LOCK_CARD':
        onBlockCard({ ysc_card_id, reason: reasonForLock });
        break;
      case 'UNLOCK_CARD':
        onUnlockCard({ ysc_card_id, reason: reasonForUnlock });
        break;
      default:
        break;
    }
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
    this.startTimer();
  }

  verifyBlockCardOTP() {
    const {
      oninitBlockYscCard,
      onResetPopup,
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
    } = this.props;
    const {
      OTP,
      selectedRadioValue,
    } = this.state;
    if (!OTP.length) {
      onResetPopup(constants.ALERT_FIELD_REQUIRED, 'error');
    } else if (OTP.length !== 6) {
      onResetPopup(constants.ALERT_OTP_MINIMUM_DIGITS, 'error');
    } else {
      const payload = {
        ysc_card_id,
        otp: OTP,
        flag: selectedRadioValue,
        remarks: 'Block Card',
      };
      oninitBlockYscCard(payload);
    }
  }

  verifyLockCardOTP() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onInitSubmitOtp,
    } = this.props;
    const { OTP } = this.state;
    onInitSubmitOtp({
      ysc_card_id,
      otp: OTP,
      action_type: 'lock_card',
    });
  }

  verifyUnlockCardOTP() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onInitSubmitOtp,
    } = this.props;
    const { OTP } = this.state;
    onInitSubmitOtp({
      ysc_card_id,
      otp: OTP,
      action_type: 'unlock_card',
    });
  }

  handleOnChange(reason, type) {
    switch (type) {
      case 'LOCK_CARD':
        this.setState({ reasonForLock: reason });
        break;
      case 'UNLOCK_CARD':
        this.setState({ reasonForUnlock: reason });
        break;
      default:
        break;
    }
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '', OTP: '', showResendText: false, remainingTime: 60,
    });
    clearInterval(this.timer);
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
  }

  blockCardClicked() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onInitPosPinReset,
    } = this.props;
    onInitPosPinReset({ ysc_card_id }, { otp_type: 'permanent_block_ysc_card' });
  }

  lockCardClicked() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onBlockCard,
    } = this.props;
    const { reasonForLock } = this.state;
    onBlockCard({ ysc_card_id, reason: reasonForLock });
  }

  unlockCardClicked() {
    const {
      match: {
        params: {
          id: ysc_card_id = '',
        } = {},
      } = {},
      onUnlockCard,
    } = this.props;
    const { reasonForUnlock } = this.state;
    onUnlockCard({ ysc_card_id, reason: reasonForUnlock });
  }

  actionPageName() {
    const {
      location: {
        pathname = '',
      } = {},
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = this.props;
    switch (pathname) {
      case `${BLOCK_CARD_PATH}/${id}`:
        return 'Block Card';
      case `${LOCK_CARD_PATH}/${id}`:
        return 'Lock Card';
      default:
        return 'Unlock Card';
    }
  }

  isDisabled() {
    const {
      location: {
        pathname = '',
      } = {},
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = this.props;
    const {
      reasonForUnlock,
      reasonForLock,
    } = this.state;
    switch (pathname) {
      case `${BLOCK_CARD_PATH}/${id}`:
        return false;
      case `${LOCK_CARD_PATH}/${id}`:
        return (
          reasonForLock.length < 5 || reasonForLock.length > 36
        );
      default:
        return (
          reasonForUnlock.length < 5 || reasonForUnlock.length > 36
        );
    }
  }

  handleOnClickAction() {
    const {
      location: {
        pathname = '',
      } = {},
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = this.props;
    switch (pathname) {
      case `${BLOCK_CARD_PATH}/${id}`:
        return this.handleModal('BLOCK_CARD_CONFIRMATION');
      case `${LOCK_CARD_PATH}/${id}`:
        return this.handleModal('LOCK_CARD_CONFIRMATION');
      default:
        return this.handleModal('UNLOCK_CARD_CONFIRMATION');
    }
  }

  cardActionReason() {
    const {
      location: {
        pathname = '',
      } = {},
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = this.props;
    switch (pathname) {
      case `${BLOCK_CARD_PATH}/${id}`:
        return 'Reason for Blocking the Card:';
      case `${LOCK_CARD_PATH}/${id}`:
        return 'Reason for Locking the Card:';
      default:
        return 'Reason for Unlocking the Card:';
    }
  }

  handleLockUnlockBlockCardAction() {
    const {
      location: {
        pathname = '',
      } = {},
      match: {
        params: {
          id = '',
        } = {},
      } = {},
      form: {
        getFieldDecorator,
      } = {},
    } = this.props;
    const {
      selectedRadioValue,
      reasonForLock,
      reasonForUnlock,
    } = this.state;
    switch (pathname) {
      case `${BLOCK_CARD_PATH}/${id}`:
        return (
          <Fragment>
            <Radio.Group
              onChange={({ target: { value } }) => this.onRadioButtonChange(value)}
              defaultValue={selectedRadioValue}
            >
              {radioOptions.map(({ value, label }) => (
                <Radio
                  className="vertical-radio-style margin-t-1"
                  value={value}
                  key={value}
                >
                  {label}
                </Radio>
              ))}
            </Radio.Group>
          </Fragment>
        );
      case `${LOCK_CARD_PATH}/${id}`:
        return (
          <Fragment>
            <Form.Item className="margin-b-1">
              {getFieldDecorator('reasonForLock', {
                rules: [validationRules.validReasonsField],
              })(
                <TextArea
                  className="rounded"
                  rows={2}
                  value={reasonForLock}
                  onChange={({ target: { value } }) => this.handleOnChange(value, 'LOCK_CARD')}
                />
              )}
            </Form.Item>
          </Fragment>
        );
      default:
        return (
          <Fragment>
            <Form.Item className="margin-b-1">
              {getFieldDecorator('reasonForUnlock', {
                rules: [validationRules.validReasonsField],
              })(

                <Input.TextArea
                  className="rounded"
                  rows={2}
                  value={reasonForUnlock}
                  onChange={({ target: { value } }) => this.handleOnChange(value, 'UNLOCK_CARD')}
                />
              )}
            </Form.Item>
          </Fragment>
        );
    }
  }

  renderYscCardActionsPage() {
    const {
      CardDataYsc: {
        card_info: {
          CardNumber = '',
        } = {},
      } = {},
      history,
      UserDetails: {
        id: user_id = '',
      } = {},
    } = this.props;
    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';
    const formattedCardNumber = `${cardnumber.slice(0, 6)}XXXX${cardnumber.slice(10)}`;
    return (
      <Col xs={24} sm={24} md={14} lg={14} xl={14}>
        <Fragment>
          <h4>Card Number:</h4>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-b-2 padding-t-1">
            <Row align="top" type="flex">
              <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                <Input
                  className="rounded font-16"
                  value={formattedCardNumber}
                  disabled
                />
              </Col>
            </Row>
          </Col>
          <h4 className="margin-l-1">{this.cardActionReason()}</h4>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-b-2 padding-t-1">
            <Row align="top" type="flex">
              <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                {this.handleLockUnlockBlockCardAction()}
              </Col>
            </Row>
          </Col>
          <Col xs={18} sm={18} md={18} lg={18} xl={18} className="text-center">
            <Button
              className="white-btn width-4 margin-r-2"
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button
              className="ant-btn green-btn width-4"
              onClick={() => this.handleOnClickAction()}
              disabled={this.isDisabled()}
            >
              {this.actionPageName()}
            </Button>
          </Col>
        </Fragment>
      </Col>
    );
  }

  renderBlockCardConfirmScreen() {
    const {
      isLoadingStatus,
    } = this.props;
    return (
      <Fragment>
        <Row align="top" type="flex" gutter={4}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left">
            <h2 className="font-18">Are you sure you want to Block the Card ?</h2>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong><b className="text-red">*</b>{YSCCARD_CONSTANTS.BLOCK_CARD_WARNING_MESSAGE}</strong><br />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right margin-t-2">
            <Button
              className="white-btn width-3"
              onClick={this.handleModal}
            >
              No
            </Button>
            <Button
              className="green-btn width-3 margin-l-1"
              onClick={() => this.blockCardClicked()}
              loading={isLoadingStatus}
            >
              Yes
            </Button>
          </Col>
        </Row>
      </Fragment>
    );
  }

  renderLockCardConfirmScreen() {
    const {
      isLoadingStatus,
    } = this.props;
    return (
      <Fragment>
        <Row align="top" type="flex" gutter={4}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left">
            <h2 className="font-18">Are you sure you want to Lock the Card ?</h2>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong><b className="text-red">*</b>{YSCCARD_CONSTANTS.LOCK_CARD_WARNING_MESSAGE}</strong><br />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right margin-t-2">
            <Button
              className="white-btn width-3"
              onClick={this.handleModal}
            >
              No
            </Button>
            <Button
              className="green-btn width-3 margin-l-1"
              onClick={() => this.lockCardClicked()}
              loading={isLoadingStatus}
            >
              Yes
            </Button>
          </Col>
        </Row>
      </Fragment>
    );
  }

  renderUnlockCardConfirmScreen() {
    const {
      isLoadingStatus,
    } = this.props;
    return (
      <Fragment>
        <Row align="top" type="flex" gutter={4}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left">
            <h2 className="font-18">Are you sure you want to Unlock the Card ?</h2>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong><b className="text-red">*</b>{YSCCARD_CONSTANTS.UNLOCK_CARD_WARNING_MESSAGE}</strong><br />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right margin-t-2">
            <Button
              className="white-btn width-3"
              onClick={this.handleModal}
            >
              No
            </Button>
            <Button
              className="green-btn width-3 margin-l-1"
              onClick={() => this.unlockCardClicked()}
              loading={isLoadingStatus}
            >
              Yes
            </Button>
          </Col>
        </Row>
      </Fragment>
    );
  }

  renderBlockCardOtpScreen() {
    const {
      CardDataYsc: {
        card_info: {
          CustomerInfo: {
            MobileNumber = '',
          } = {},
        } = {},
      } = {},
      isLoadingStatus,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <CardActionsPage
        type="BLOCK_CARD"
        MobileNumber={MobileNumber}
        isLoadingStatus={isLoadingStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOtpChange={this.handleOtpChange}
        handleResendOTP={() => this.handleResendOTP('BLOCK_CARD')}
        verifyBlockCardOTP={this.verifyBlockCardOTP}
      />
    );
  }

  renderLockCardOtpScreen() {
    const {
      CardDataYsc: {
        card_info: {
          CustomerInfo: {
            MobileNumber = '',
          } = {},
        } = {},
      } = {},
      isLoadStatus,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <CardActionsPage
        type="LOCK_CARD"
        MobileNumber={MobileNumber}
        isLoadStatus={isLoadStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOtpChange={this.handleOtpChange}
        handleResendOTP={() => this.handleResendOTP('LOCK_CARD')}
        verifyLockCardOTP={this.verifyLockCardOTP}
      />
    );
  }

  renderUnlockCardOtpScreen() {
    const {
      CardDataYsc: {
        card_info: {
          CustomerInfo: {
            MobileNumber = '',
          } = {},
        } = {},
      } = {},
      isLoadStatus,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <CardActionsPage
        type="UNLOCK_CARD"
        MobileNumber={MobileNumber}
        isLoadStatus={isLoadStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOtpChange={this.handleOtpChange}
        handleResendOTP={() => this.handleResendOTP('UNLOCK_CARD')}
        verifyUnlockCardOTP={this.verifyUnlockCardOTP}
      />
    );
  }

  renderModalHeader(modalType) {
    switch (modalType) {
      case 'BLOCK_CARD_OTP':
      case 'LOCK_CARD_OTP':
      case 'UNLOCK_CARD_OTP':
        return (
          <h4 className="font-20 text-center">OTP Verification</h4>
        );
      default:
        return '';
    }
  }

  renderModalUI(modalType) {
    switch (modalType) {
      case 'BLOCK_CARD_CONFIRMATION':
        return this.renderBlockCardConfirmScreen();
      case 'LOCK_CARD_CONFIRMATION':
        return this.renderLockCardConfirmScreen();
      case 'UNLOCK_CARD_CONFIRMATION':
        return this.renderUnlockCardConfirmScreen();
      case 'BLOCK_CARD_OTP':
        return this.renderBlockCardOtpScreen();
      case 'UNLOCK_CARD_OTP':
        return this.renderUnlockCardOtpScreen();
      case 'LOCK_CARD_OTP':
        return this.renderLockCardOtpScreen();
      default:
        return <div />;
    }
  }

  renderModalCloseFunction(modalType) {
    switch (modalType) {
      case 'BLOCK_CARD_CONFIRMATION':
      case 'LOCK_CARD_CONFIRMATION':
      case 'UNLOCK_CARD_CONFIRMATION':
      case 'BLOCK_CARD_OTP':
      case 'LOCK_CARD_OTP':
      case 'UNLOCK_CARD_OTP':
        return this.handleModal;
      default:
        return () => '';
    }
  }

  renderCardImages(CardDataYsc) {
    const {
      card_info: {
        CVV = '',
      } = {},
    } = CardDataYsc;
    return CVV ? this.renderCvvPresentImage(CardDataYsc) : this.renderCvvBlankImage(CardDataYsc);
  }

  renderCvvPresentImage(CardDataYsc) {
    const {
      UserDetails: {
        id: user_id = '',
      } = {},
    } = this.props;
    const {
      card_info: {
        CVV = '',
        Expirydate = '',
        CardStatus = '',
        CardNumber = '',
        BankName = '',
        Network = '',
        ProductType = '',
      } = {},
    } = CardDataYsc;

    const cvv = (user_id && CVV && CVV.length) ? utils.getDecryptedData(CVV, user_id) : '';
    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';

    const showImage = (
      <Fragment>
        <input type="checkbox" id="CardClick" />
        <label className="card-containert" htmlFor="CardClick">
          <div className="card-flip">
            <div className="side default-user" >
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1> : ''}
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <div className="footer">
                  <b>
                    <span>Card Number:</span> {cardnumber}<br />
                    <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                    <span>Card Status:</span> {CardStatus}<br />
                  </b>
                </div> :
                <b style={background}>
                  <h1 style={backgroundColour}><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
                  <span>Card Number:</span> {cardnumber}<br />
                  <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                  <span>Card Status:</span> {CardStatus}<br />
                </b>
              }
            </div>
            <div className="side back">
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <h3>{cvv}</h3> : <h3 style={margin}>{cvv}</h3>}
            </div>
          </div>
        </label>
      </Fragment>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        {BankName && BankName.toLowerCase() === 'indusind bank' && (
          <StyledYscFlipCards
            network={Network}
            product={ProductType}
            bankName={BankName}
          >
            {showImage}
          </StyledYscFlipCards>
        )}
        {BankName && BankName.toLowerCase() === 'idfc first bank' && (
          <StyledIdfcFlipCards bankName={BankName}>
            {showImage}
          </StyledIdfcFlipCards>
        )}
      </Col>
    );
  }

  renderCvvBlankImage(CardDataYsc) {
    const {
      UserDetails: {
        id: user_id = '',
      } = {},
    } = this.props;
    const {
      card_info: {
        CardName = '',
        ExpiryDate = '',
        CardStatus = '',
        CardNumber = '',
        BankName = '',
        Network = '',
        ProductType = '',
      } = {},
    } = CardDataYsc;
    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';
    const showImage = (
      <div className="card-flip default">
        <div className="side default-user" >
          <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
          <h2>{CardName}</h2>
          <div className="footer">
            <Row align="middle" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <b>
                  <span>Card Number:</span> {cardnumber}<br />
                  {ExpiryDate ? <Fragment><span>Expiry:</span> {formatExpiryDate(ExpiryDate)}<br /></Fragment> : null}
                  <span>Card Status:</span> {CardStatus}<br />
                </b>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        {BankName && BankName.toLowerCase() === 'indusind bank' && (
          <StyledYscFlipCards
            network={Network}
            product={ProductType}
            bankName={BankName}
          >
            {showImage}
          </StyledYscFlipCards>
        )}
        {BankName && BankName.toLowerCase() === 'idfc first bank' && (
          <StyledIdfcFlipCards bankName={BankName}>
            {showImage}
          </StyledIdfcFlipCards>
        )}
      </Col>
    );
  }

  render() {
    const {
      CardDataYsc = {},
    } = this.props;
    const { modalType } = this.state;
    return (
      <div>
        <Modal
          visible={!!modalType}
          title={this.renderModalHeader(modalType)}
          size="sm"
          onCancel={this.renderModalCloseFunction(modalType)}
          classname="default-popup"
          footer={null}
          maskClosable={false}
          width={this.setWidth(modalType)}
        >
          {modalType && this.renderModalUI(modalType)}
        </Modal>
        <br clear="all" />
        <Fragment>
          <Container className="margin-t-2">
            <Row align="top" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
                <h1 className="margin-b-1 font-20">Manage Zaggle Cards</h1>
                <Breadcrumb separator="<">
                  <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
                  <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
                  <Breadcrumb.Item>{this.actionPageName()}</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded card-padding-20 noborder noshadow margin-t-2">
              <Row align="middle" type="flex" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h2 className="font-18">{this.actionPageName()}</h2>
                </Col>
              </Row>
              <Divider />
              <Row align="top" type="flex" gutter={[15, 15]}>
                {this.renderCardImages(CardDataYsc)}
                {this.renderYscCardActionsPage()}
              </Row>
            </Card>
          </Container>
        </Fragment>
      </div>
    );
  }
}

YscCardActions.propTypes = YscCardActionsProps;

const YscCardActionsWrapper = Form.create({ name: 'normal_admin' })(YscCardActions);
export default connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(YscCardActionsWrapper));
export { YscCardActions };



// WEBPACK FOOTER //
// client/containers/YscCardActions/index.js